import React, { Component } from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'

import Header from './components/Header'
import Body from './components/Body'

import './style.scss'

export default class FixedColumn extends Component {
    static propTypes = {
        activeRowIndex: PropTypes.string,
        addOpenRow: PropTypes.func.isRequired,
        currentStandard: PropTypes.string,
        data: PropTypes.array,
        handleCurrentStandardChange: PropTypes.func,
        handleMouseLeaveRow: PropTypes.func.isRequired,
        handleRowHover: PropTypes.func.isRequired,
        id: PropTypes.string.isRequired,
        isAdvanced: PropTypes.bool.isRequired,
        openRows: PropTypes.array,
        // Definition of table sections and rows
        removeOpenRows: PropTypes.func.isRequired,
        sectionsDefinition: PropTypes.arrayOf(
            PropTypes.shape({
                title: PropTypes.string.isRequired,
                rows: PropTypes.arrayOf(
                    PropTypes.shape({
                        prefix: PropTypes.string,
                        highlight: PropTypes.bool,
                        text: PropTypes.string.isRequired,
                        columnCode: PropTypes.string.isRequired,
                        indentationLevel: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
                        configuration: PropTypes.shape({
                            unit: PropTypes.string,
                            higherIsBetter: PropTypes.string,
                        }),
                    })
                ).isRequired,
            })
        ),
        setOpenRows: PropTypes.func.isRequired,
        showRowTooltips: PropTypes.bool.isRequired,
        standards: PropTypes.array,
        tableType: PropTypes.string.isRequired,
        translates: PropTypes.shape({
            exportAsImage: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
            standardsText: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
            standardsDropdownText: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
            emptySections: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
            noStandardSelected: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
            availableYears: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
            units: PropTypes.shape({
                days: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
                ratio: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
                percent: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
            }).isRequired,
            tooltips: PropTypes.shape({
                fi1008: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
                fi1009: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
                fi1016: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
                fi1004: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
                fi1005: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
                fi1006: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
                fi1001: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
                fi1002: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
                fi1018: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
                fi1021: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
                fi1023: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
                fi1024: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
                fi1025: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
            }).isRequired,
        }).isRequired,
    }

    componentDidUpdate(prevProps) {
        const { id, sectionsDefinition, setOpenRows, tableType } = this.props

        if (!_.isEqual(prevProps.sectionsDefinition, sectionsDefinition)) {
            const sectionRows = _.reduce(
                sectionsDefinition,
                (acc, section) => [...acc, ..._.get(section, 'rows', [])],
                []
            )
            const defaultOpenRows = _.reduce(
                sectionRows,
                (acc, row) => {
                    if (
                        _.get(row, 'indentationLevel') === 0 &&
                        _.find(sectionRows, { parentNode: _.get(row, 'columnCode') })
                    ) {
                        return [...acc, _.get(row, 'columnCode')]
                    }

                    return acc
                },
                []
            )

            setOpenRows(id, tableType, defaultOpenRows)
        }
    }

    render() {
        const {
            activeRowIndex,
            data,
            isAdvanced,
            translates,
            currentStandard,
            standards,
            id,
            addOpenRow,
            removeOpenRows,
            setOpenRows,
            handleCurrentStandardChange,
            sectionsDefinition,
            handleMouseLeaveRow,
            handleRowHover,
            showRowTooltips,
            openRows,
            tableType,
        } = this.props

        return (
            <div className={'fixed-column-container'}>
                <div className={'fixed-column-header'}>
                    <Header
                        id={id}
                        data={data}
                        isAdvanced={isAdvanced}
                        currentStandard={currentStandard}
                        handleCurrentStandardChange={handleCurrentStandardChange}
                        standards={standards}
                        translates={translates}
                        setOpenRows={setOpenRows}
                        sectionsDefinition={sectionsDefinition}
                        tableType={tableType}
                    />
                </div>
                <div className={'fixed-column-body'}>
                    <Body
                        id={id}
                        addOpenRow={addOpenRow}
                        removeOpenRows={removeOpenRows}
                        isAdvanced={isAdvanced}
                        openRows={openRows}
                        sectionsDefinition={sectionsDefinition}
                        activeRowIndex={activeRowIndex}
                        handleMouseLeaveRow={handleMouseLeaveRow}
                        handleRowHover={handleRowHover}
                        showRowTooltips={showRowTooltips}
                        tableType={tableType}
                        translates={translates}
                    />
                </div>
            </div>
        )
    }
}
